import React from "react"
import { Link } from "gatsby"
import Image from "./image"
import "./thoughts.css"

export const formatThoughtDate = date =>
  new Intl.DateTimeFormat("en", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(new Date(`${date}T12:00:00`))

export const ThoughtsContact = () => (
  <section
    className="thoughts-contact"
    aria-labelledby="thoughts-contact-title"
  >
    <div>
      <h2 id="thoughts-contact-title">Working through a product decision?</h2>
      <p>
        If you are shaping something new or trying to unblock an important
        decision, I am happy to compare notes.
      </p>
    </div>
    <div className="thoughts-contact__actions">
      <a
        className="thoughts-contact__button"
        href="https://calendly.com/rahulv/30min"
        target="_blank"
        rel="noopener noreferrer"
      >
        Start a conversation
      </a>
      <a
        className="thoughts-contact__email"
        href="mailto:rahul.vagadiya@gmail.com?subject=Building%20a%20product%20together"
      >
        Email me directly <span aria-hidden="true">→</span>
      </a>
    </div>
  </section>
)

const ThoughtCard = ({ thought, showExcerpt }) => (
  <article className="thought-card">
    <time className="thought-date" dateTime={thought.date}>
      {formatThoughtDate(thought.date)}
    </time>
    <h3>
      <Link to={`/thoughts/${thought.slug}/`}>{thought.title}</Link>
    </h3>
    {thought.image && (
      <Image
        alt=""
        aria-hidden="true"
        fileName={thought.image}
        className="thought-image rv-rounded-md rv-overflow-hidden"
      />
    )}
    <p>{showExcerpt ? thought.excerpt : thought.description}</p>
    <Link className="thought-link" to={`/thoughts/${thought.slug}/`}>
      Read more →
    </Link>
  </article>
)

const Thoughts = ({
  thoughts,
  title = "Thoughts",
  limit,
  showMoreLink = false,
  showExcerpt = false,
  summary = "",
}) => {
  const displayedThoughts = limit ? thoughts.slice(0, limit) : thoughts

  return (
    <section className="thoughts" aria-labelledby="thoughts-heading">
      {title && <h2 id="thoughts-heading">{title}</h2>}
      {summary && <p className="thoughts-intro rv-pb-4">{summary}</p>}
      <div className="thought-list">
        {displayedThoughts.map(thought => (
          <ThoughtCard
            key={thought.slug}
            thought={thought}
            showExcerpt={showExcerpt}
          />
        ))}
      </div>
      {showMoreLink && (
        <Link className="thought-all-link" to="/thoughts/">
          All thoughts →
        </Link>
      )}
    </section>
  )
}

export default Thoughts
